import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'systemConfigs';
export const systemConfigsActions = makeActions(MODEL_NAME, 'id', 'system-configs');

export const getAllSystemConfigs = systemConfigsActions.getAll;
export const editSystemConfigs = systemConfigsActions.edit;
export const createSystemConfigs = systemConfigsActions.create;
export const getByIdSystemConfigs = systemConfigsActions.getDataById;
